import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FeatureGateEnvironment, PerimeterType } from '@atlaskit/feature-gate-js-client';
import FeatureGateClient from '@atlaskit/feature-gate-js-client/client';
import { MaintenanceNone } from '@atlassian/mpac-types';
export { FeatureGateEnvironment as StatsigEnvironment };
export class StatsigClient {
  constructor() {
    var _this = this;
    _defineProperty(this, "marketplaceClientInstance", undefined);
    _defineProperty(this, "isStatsigInitialized", false);
    _defineProperty(this, "evaluatedFlags", {});
    _defineProperty(this, "evaluatedExperiments", {});
    _defineProperty(this, "source", undefined);
    _defineProperty(this, "customAttributes", void 0);
    _defineProperty(this, "clientOptions", void 0);
    _defineProperty(this, "identifers", void 0);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _defineProperty(this, "overrides", {});
    _defineProperty(this, "getExperimentValue", function (experimentName, propertyName) {
      var _this$marketplaceClie;
      let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      let options = arguments.length > 3 ? arguments[3] : undefined;
      if (!_this.isStatsigInitialized || !_this.marketplaceClientInstance) {
        console.warn('Statsig client not initialized.');
        return defaultValue;
      }
      if (_this.overrides[experimentName] !== undefined && _this.overrides[experimentName][propertyName] !== undefined) {
        return _this.overrides[experimentName][propertyName];
      }
      const evaluatedValue = (_this$marketplaceClie = _this.marketplaceClientInstance.getExperimentValue(experimentName, propertyName, defaultValue, options)) !== null && _this$marketplaceClie !== void 0 ? _this$marketplaceClie : defaultValue;
      _this.evaluatedExperiments = _objectSpread(_objectSpread({}, _this.evaluatedExperiments), {}, {
        [experimentName]: _objectSpread(_objectSpread({}, _this.evaluatedExperiments[experimentName]), {}, {
          [propertyName]: evaluatedValue
        })
      });
      return evaluatedValue;
    });
    _defineProperty(this, "checkGate", function (gateName) {
      var _this$marketplaceClie2;
      let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (_this.overrides[gateName] !== undefined) {
        return Boolean(_this.overrides[gateName]);
      }
      if (!_this.isStatsigInitialized || !_this.marketplaceClientInstance) {
        console.warn('Statsig client not initialized.');
        return defaultValue;
      }
      const evaluatedValue = (_this$marketplaceClie2 = _this.marketplaceClientInstance.checkGate(gateName)) !== null && _this$marketplaceClie2 !== void 0 ? _this$marketplaceClie2 : defaultValue;
      _this.evaluatedFlags[gateName] = evaluatedValue;
      return evaluatedValue;
    });
    _defineProperty(this, "getDynamicConfig", (configName, defaultValue) => {
      var _configValue$value;
      if (!this.isStatsigInitialized || !this.marketplaceClientInstance) {
        console.warn('Statsig client not initialized.');
        return defaultValue;
      }
      const configValue = this.marketplaceClientInstance.getExperiment(configName);
      return (configValue === null || configValue === void 0 ? void 0 : (_configValue$value = configValue.value) === null || _configValue$value === void 0 ? void 0 : _configValue$value.value) || defaultValue;
    });
    _defineProperty(this, "initializeStatsigClientWithValues", async (_ref, source) => {
      let {
        marketplaceAnonymousId,
        environment,
        targetApp,
        clientSdkKey,
        experimentValues,
        customAttributes
      } = _ref;
      this.source = source;
      const featureGates = new FeatureGateClient();
      this.marketplaceClientInstance = featureGates;
      await this.marketplaceClientInstance.initializeFromValues({
        environment,
        targetApp,
        sdkKey: clientSdkKey
      }, {
        marketplaceAnonymousId
      }, customAttributes, experimentValues);
      this.isStatsigInitialized = true;
    });
    _defineProperty(this, "updateIdentifiers", async overrideIdentifiers => {
      if (!this.marketplaceClientInstance || !this.isStatsigInitialized || !this.clientOptions) {
        console.warn('Statsig client not initialized.');
        return;
      }
      const {
        environment,
        apiKey,
        targetApp
      } = this.clientOptions;
      this.identifers = _objectSpread(_objectSpread({}, this.identifers), overrideIdentifiers);
      try {
        await this.marketplaceClientInstance.updateUser({
          environment,
          apiKey,
          targetApp,
          // this is optional in FeatureGates.initialize but required for FeatureGates.updateUser
          // COMMERCIAL is the default value for perimeter if we don't provide one
          perimeter: PerimeterType.COMMERCIAL
        }, this.identifers, this.customAttributes);
      } catch (err) {
        console.error('Failed to update identifiers.', err);
      }
    });
    _defineProperty(this, "setOverride", overrideValues => {
      this.overrides = overrideValues;
    });
    _defineProperty(this, "checkEnableGateById", featureGateId => {
      return this.checkGate(featureGateId);
    });
    _defineProperty(this, "getEvaluatedFlags", () => {
      return this.evaluatedFlags;
    });
    _defineProperty(this, "getEvaluatedExperiments", () => {
      return this.evaluatedExperiments;
    });
    _defineProperty(this, "getMarketplaceClientInstance", () => {
      return this.marketplaceClientInstance;
    });
    _defineProperty(this, "getIsStatsigInitialized", () => {
      return this.isStatsigInitialized;
    });
    // ---------------------- Experiments EMCEE-------------------------
    /**
     * discussion: https://atlassian.enterprise.slack.com/archives/C04PR2YE4UC/p1725317404567309?thread_ts=1725277152.022099&channel=C04PR2YE4UC&message_ts=1725317404.567309
     * suggests that the exposures from the other target apps will cause issues, and recommends either suppressing the experiment or adding an in-code check
     **/
    // ---------------------- Experiments MPAC-------------------------
    _defineProperty(this, "enableNlpSearch", function () {
      let {
        fireExperimentExposure = false
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (_this.source === 'PRODUCT') {
        return false;
      }
      if (_this.source === 'MPAC') {
        return _this.getExperimentValue('enable_mpac_nlp_search_experiment', 'isExperienceEnabled', false, {
          fireExperimentExposure
        });
      }
      return false;
    });
    _defineProperty(this, "enableStaticBundlePages", function () {
      let {
        fireExperimentExposure = false
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (_this.source === 'PRODUCT') {
        return false;
      }
      if (_this.source === 'MPAC') {
        const experimentValue = _this.getExperimentValue('enable_static_bundle_pages_experiment', 'position', 'none', {
          fireExperimentExposure
        });
        return experimentValue === 'above' || experimentValue === 'below';
      }
      return false;
    });
    _defineProperty(this, "enableStaticBundlePagesAboveVariant", () => {
      if (this.source === 'PRODUCT') {
        return false;
      }
      if (this.source === 'MPAC') {
        const experimentValue = this.getExperimentValue('enable_static_bundle_pages_experiment', 'position', 'none');
        return experimentValue === 'above';
      }
      return false;
    });
    _defineProperty(this, "enableStaticBundlePagesBelowVariant", () => {
      if (this.source === 'PRODUCT') {
        return false;
      }
      if (this.source === 'MPAC') {
        const experimentValue = this.getExperimentValue('enable_static_bundle_pages_experiment', 'position', 'none');
        return experimentValue === 'below';
      }
      return false;
    });
    _defineProperty(this, "enableSponsoredAboveExperiment", () => {
      if (this.source === 'PRODUCT') {
        return false;
      }
      if (this.source === 'MPAC') {
        const position = this.getExperimentValue('enable_sponsored_listing_mpac', 'position', 'none');
        return position === 'above';
      }
      return false;
    });
    _defineProperty(this, "enableSponsoredBelowExperiment", () => {
      if (this.source === 'PRODUCT') {
        return false;
      }
      if (this.source === 'MPAC') {
        const position = this.getExperimentValue('enable_sponsored_listing_mpac', 'position', 'none');
        return position === 'below';
      }
      return false;
    });
    _defineProperty(this, "enableOneClickAppInstall", () => {
      if (this.source === 'MPAC') {
        return this.getExperimentValue('enable_one_click_install_mpac', 'isExperienceEnabled', false);
      }
      if (this.source === 'PRODUCT') {
        return this.checkGate('enable_emcee_one_click_install');
      }
      return false;
    });
    _defineProperty(this, "enableAtlassianAppsInEmbeddedMarketplace", function () {
      let {
        fireExperimentExposure = false
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (_this.source === 'PRODUCT') {
        return _this.getExperimentValue('atlassian_apps_in_embedded_marketplace', 'cohort', 'not-enrolled', {
          fireExperimentExposure
        });
      }
      return 'not-enrolled';
    });
    _defineProperty(this, "enableCategoriesSectionExperiment", () => {
      if (this.source === 'PRODUCT') {
        return false;
      }
      if (this.source === 'MPAC') {
        return this.getExperimentValue('categories_section_mpac_homepage', 'isExperienceEnabled', false);
      }
      return false;
    });
    // ---------------------- Feature Flags ----------------------
    _defineProperty(this, "enableStaffPickOnAppListing", () => {
      return this.checkGate('enable_staff_pick_on_app_listing');
    });
    _defineProperty(this, "enableTwoClickAppInstall", () => {
      return this.checkGate('enable_two_step_app_installation_marketplace');
    });
    _defineProperty(this, "showCompassApps", () => {
      return this.checkGate('show_compass_apps');
    });
    _defineProperty(this, "showTeamworkGraphConnectors", () => {
      return this.checkGate('show_teamwork_graph_connectors');
    });
    _defineProperty(this, "showNewJiraSoftwareLabel", () => {
      return this.checkGate('show_new_jira_software_label');
    });
    _defineProperty(this, "showChangemakersCollectionTile", () => {
      return this.checkGate('show_changemakers_collection_tile');
    });
    _defineProperty(this, "enableCurrentUserApiViaStoreBff", () => {
      return this.checkGate('enable_current_user_api_via_store_bff');
    });
    _defineProperty(this, "enableGeoIPFromStoreBff", () => {
      return this.checkGate('enable_geoip_from_store_bff', true);
    });
    _defineProperty(this, "enableTrustCenterSection", () => {
      return this.checkGate('enable_trustcenter_section');
    });
    _defineProperty(this, "enableTrustCenterNewLozenge", () => {
      return this.checkGate('enable_trust_center_new_lozenge');
    });
    _defineProperty(this, "enableConsoleLdVersionPublishFlow", () => {
      return this.checkGate('enable_console_ld_version_publish_flow');
    });
    _defineProperty(this, "enableMediaFromProductListing", () => {
      return this.checkGate('enable_media_from_product_listing');
    });
    _defineProperty(this, "enableAppBundles", () => {
      return this.checkGate('enable_app_bundles');
    });
    _defineProperty(this, "enableTeamsWithMakerIntegration", () => {
      return this.checkGate('partner_teams_tab_maker_integration');
    });
    _defineProperty(this, "displayAuditTabInManagePartnerPage", () => {
      return this.checkGate('display_audit_tab_in_manage_partner_page');
    });
    _defineProperty(this, "enableAlgoliaCallOnAppListingAndDialogs", () => {
      return this.checkGate('enable_algolia_call_on_applising_and_dialogs');
    });
    _defineProperty(this, "enableEditionsGA", () => {
      return this.checkGate('enable_partner_app_edition_tab');
    });
    _defineProperty(this, "enableCapabilitySets", () => {
      return this.getDynamicConfig('enablecapabilitysets', []);
    });
    _defineProperty(this, "enableScalingLogicOnUI", () => {
      return this.checkGate('enable_scaling_logic_on_ui');
    });
    _defineProperty(this, "enablePartnerFreeAppEditionsView", () => {
      return this.checkGate('enable_partner_free_app_editions_view');
    });
    _defineProperty(this, "enablePartnerUserApiViaConsoleBffGql", () => {
      return this.checkGate('enable_partner_user_api_via_console_bff_gql');
    });
    _defineProperty(this, "enablePartnerPaymentsViaConsoleBff", () => {
      return this.checkGate('enable_partner_payments_via_console_bff');
    });
    _defineProperty(this, "partnersNavigationRefresh", () => {
      return this.checkGate('partners_navigation_refresh');
    });
    _defineProperty(this, "enableMarketplaceThemeToggle", () => {
      return this.checkGate('enable_marketplace_theme_toggle');
    });
    _defineProperty(this, "enableForgeRemoteDataResidencyChangesV2", () => this.checkGate('forge_remote_data_residency_changes_v2'));
    _defineProperty(this, "enableRunsOnAtlassian", () => {
      // Show other Runs on Atlassian changes in marketplace/emcee only if two-step installation is enabled.
      return this.checkGate('enable_two_step_app_installation_marketplace');
    });
    _defineProperty(this, "enableAppReviewSummaryFromStoreBff", () => {
      if (this.source === 'PRODUCT') {
        return this.checkGate('get_app_review_summary_for_emcee_from_store_bff');
      }
      if (this.source === 'MPAC') {
        return this.checkGate('get_app_review_summary_for_mpac_from_store_bff');
      }
      return false;
    });
    _defineProperty(this, "enableAppReviewsFromStoreBff", () => this.checkGate('enable_app_reviews_from_store_bff'));
    _defineProperty(this, "showUpdatedPartnerTierMessage", () => this.checkGate('partner_tier_messaging_update'));
    _defineProperty(this, "enableBontermsSupported", () => this.checkGate('enable_marketplace_bon_terms'));
    _defineProperty(this, "enableAtlassianLabsPartnerBontermsRestriction", () => this.checkGate('enable_atlassian_labs_partner_bonterms_restriction'));
    _defineProperty(this, "getMaintenanceBannerConfiguration", () => {
      const defaultMaintenanceBannerConfig = JSON.stringify(MaintenanceNone);
      return this.getDynamicConfig('marketplace_maintenance_banner_configuration', defaultMaintenanceBannerConfig);
    });
    _defineProperty(this, "enableProratedDetails", () => this.checkGate('enable_overage_details_for_transactions'));
    _defineProperty(this, "enablePrivacySecurityRoAChanges", () => {
      return this.checkGate('enable_privacy_security_roa_fe');
    });
    _defineProperty(this, "enableLdReportingChanges", () => {
      return this.checkGate('enable_reporting_ui_ld_changes');
    });
    _defineProperty(this, "enableAppTileUtilsRefactor", () => this.checkGate('enable_app_tile_utils_refactor'));
    _defineProperty(this, "blockPublicVersionCompatibilityEditing", () => {
      return this.checkGate('block_public_version_compatibility_editing');
    });
    _defineProperty(this, "archivedVendorPageView", () => {
      return this.checkGate('enable_archive_vendor_amkt');
    });
    // ---------------------- Permanent Feature Flags ----------------------
    _defineProperty(this, "enableDcMarketplaceDownloadSignature", () => {
      return this.checkGate('enable-dc-marketplace-download-signature');
    });
    _defineProperty(this, "showRevampedCloudPricingTab", () => this.checkGate('show_revamped_cloud_pricing_tab'));
    _defineProperty(this, "enableFedrampPartnerJourneys", () => this.checkGate('enable_fedramp_partner_journeys'));
    _defineProperty(this, "enableICPartnerJourneyUI", () => this.checkGate('enable_ic_partner_journey_ui'));
    _defineProperty(this, "enableBypassForgeAppCheckForAGCVersionCreate", () => this.checkGate('enable_bypass_forge_app_check_agc_version_create'));
    _defineProperty(this, "enable150KTierSupport", () => this.checkGate('enable_150k_tier_support'));
    _defineProperty(this, "fetchHostProductPricingFromConsoleBff", () => this.checkGate('fetch_parent_product_pricing_from_console_bff'));
    _defineProperty(this, "enablePrivacyAndSecurityQuestionary", () => this.checkGate('pegasus_privacy_questions'));
    _defineProperty(this, "enableCustomer150kTierSupport", () => this.checkGate('enable_customer_150k_tiers'));
    _defineProperty(this, "showEditionsAnnouncementAlert", () => this.checkGate('show_editions_announcement_alert'));
    _defineProperty(this, "enableSelfServeAppEditions", () => this.checkGate('enable_self_serve_app_editions_view'));
    _defineProperty(this, "enableFreeAppEditionsView", () => this.checkGate('enable_free_app_editions_view'));
    _defineProperty(this, "enableAdvancedExperimentOnPricingTab", () => {
      if (this.source === 'PRODUCT') {
        return false;
      }
      if (this.source === 'MPAC') {
        return this.getExperimentValue('advanced_experimentation_on_pricing_tab', 'isExperienceEnabled', false);
      }
      return false;
    });
    _defineProperty(this, "enableDemandServiceSiteDetailsDomainChange", () => this.checkGate('custom_domain_site_demand_service_domain_change'));
    _defineProperty(this, "enableMILsupport", () => this.checkGate('enable_mil_support'));
    _defineProperty(this, "enableDevopsEssentialsBundlePage", () => this.checkGate('enable_devops_essentials_bundle_page'));
    _defineProperty(this, "enableMILReportingSupport", () => this.checkGate('enable_mil_reporting_support'));
    _defineProperty(this, "enableAppEditionM3ReportingSupport", () => this.checkGate('enable_app_edition_m3_reporting_support'));
    _defineProperty(this, "enableMpacWebCoherence", () => this.checkGate('enable_mpac_web_coherence'));
    _defineProperty(this, "enableMpacSsrSearch", () => this.checkGate('enable_mpac_ssr_search_page'));
    _defineProperty(this, "enableMILCustomerSupport", () => this.checkGate('enable_mil_customer_support'));
    _defineProperty(this, "enableLdCustomerGaChanges", () => this.checkGate('enable_ld_customer_ga_changes'));
    _defineProperty(this, "enableMILPricingDialog", () => this.checkGate('enable_mil_pricing_dialog'));
    _defineProperty(this, "enableV4SearchIndex", () => this.checkGate('enable_v4_search_index'));
    _defineProperty(this, "enableV4QuerySuggestionsSearchIndex", () => this.checkGate('enable_v4_query_suggestions_search_index'));
    _defineProperty(this, "allowRequestApp", () => this.checkGate('request-app'));
    _defineProperty(this, "enableDiscountBreakdown", () => this.checkGate('enable_partner_discount_breakdown'));
    _defineProperty(this, "enableGLPReportingSupport", () => this.checkGate('enable_glp_reporting_support'));
    _defineProperty(this, "getMpacConfiguration", () => {
      return this.getDynamicConfig('mpac_configurator', '');
    });
    _defineProperty(this, "enableMpacConfigurator", () => this.checkGate('enable_mpac_configurator'));
    _defineProperty(this, "enableDetailedVersionHistoryCounts", () => this.checkGate('enable_detailed_version_history_counts'));
    _defineProperty(this, "enableCanonicalUrlRedirectionHandler", () => this.checkGate('enable-canonical-url-redirection-handler'));
    _defineProperty(this, "enablePricingTabOnEmcee", () => this.checkGate('enable_pricing_tab_on_emcee'));
    _defineProperty(this, "enable100kJiraCloud", () => this.checkGate('enable_100k_jira_cloud_for_mpac'));
    _defineProperty(this, "enableIsolatedCloudChanges", () => this.checkGate('enable_isolated_cloud_customer_journeys'));
    _defineProperty(this, "enableFedrampChanges", () => this.checkGate('enable_fedramp_customer_journeys'));
    _defineProperty(this, "enableRegulatedSectorMenuButtonForFedramp", () => this.checkGate('enable_regulated_sector_menu_button_for_fedramp'));
    _defineProperty(this, "enableRegulatedSectorButtonForIsolatedCloud", () => this.checkGate('enable_regulated_sector_button_for_isolated_cloud'));
    _defineProperty(this, "enableAppInstallConsentCheck", () => this.checkGate('enable_app_install_consent_check'));
    _defineProperty(this, "enableLicenseDecouplingPartner", () => this.checkGate('enable-license-decoupling-partner'));
    _defineProperty(this, "enableStoreBffForFreeJiraConfluenceApps", () => this.checkGate('enable_store_bff_for_free_jira_confluence_apps'));
    _defineProperty(this, "enableSetAdvancedEditionPriceFromPricingTab", () => this.checkGate('enable_set_advanced_edition_price_from_pricing_tab'));
    _defineProperty(this, "redirectUserToMpacInRegulatedEnvEmcee", () => this.checkGate('redirect_user_to_mpac_in_regulated_env_emcee'));
    _defineProperty(this, "enableFlexibleBillingFilter", () => this.checkGate('enable_flexible_billing_filter_for_ld'));
    _defineProperty(this, "enableConnectRampdown", () => this.checkGate('enable_connect_ramp_down'));
    _defineProperty(this, "showConnectRampdownBanner", () => this.checkGate('show_connect_rampdown_banner'));
    _defineProperty(this, "enableHomepageSpotlight", function () {
      let {
        fireExperimentExposure = false
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _this.getExperimentValue('enable_homepage_spotlight_experiment', 'isExperienceEnabled', false, {
        fireExperimentExposure
      });
    });
    _defineProperty(this, "enableIssueTerminology", () => this.checkGate('enable_issue_terminology_changes_mpac'));
    _defineProperty(this, "enableAppificationChanges", () => this.checkGate('enable_appification_for_mpac'));
    _defineProperty(this, "enableMpacAgentsPageView", () => this.checkGate('enable_mpac_agents_page_view'));
    _defineProperty(this, "enableMakerContactApisMpac", () => this.checkGate('enable_maker_contact_api_on_mpac'));
    _defineProperty(this, "showDCEosMessaging", () => this.checkGate('data_center_end_of_service_information_banner'));
    _defineProperty(this, "enableManageVendorCreatePageView", () => this.checkGate('enable_manage_vendor_create_page_view'));
    _defineProperty(this, "enableManageAppCreatePageView", () => this.checkGate('enable_manage_app_create_page_view'));
    _defineProperty(this, "enableXcaConsolePublishFlowChanges", () => this.checkGate('enable_xca_console_publish_flow_changes'));
    _defineProperty(this, "getAiAgentStatsConfiguration", () => {
      return this.getDynamicConfig('ai_agent_stats_configurator', [10000, 1300]);
    });
    _defineProperty(this, "enableMpacPstModalEnhancement", () => this.checkGate('mpac_pst_modal_enhancement'));
    _defineProperty(this, "enableAppListingSSROptimization", () => this.checkGate('enable_mpac_app_listing_ssr_optimization'));
  }
  // IMPORTANT: Calling this method will completely re-initialize the client with a new set of flags. You will need to re-render the entire page after this completes to ensure everything picks up the new flag values. You should avoid using this frequently as it has implications on the user experience.
  async initializeStatsigClient(_ref2) {
    let {
      clientKey,
      environment,
      targetApp,
      marketplaceAnonymousId,
      tenantId,
      atlassianAccountId
    } = _ref2;
    let customAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let source = arguments.length > 2 ? arguments[2] : undefined;
    this.source = source;
    const clientOptions = {
      apiKey: clientKey,
      environment,
      targetApp,
      fetchTimeoutMs: 5000
    };
    const identifiers = {
      marketplaceAnonymousId,
      tenantId,
      atlassianAccountId
    };
    try {
      const featureGates = new FeatureGateClient();
      this.marketplaceClientInstance = featureGates;
      await this.marketplaceClientInstance.initialize(clientOptions, identifiers, customAttributes);
      this.isStatsigInitialized = true;
      this.identifers = identifiers;
      this.clientOptions = clientOptions;
      this.customAttributes = customAttributes;
    } catch (err) {
      console.error('Failed to initialize FeatureGates client.', err);
    }
  }
}
export default StatsigClient;